"use strict";
exports.__esModule = true;
exports.Oauth = void 0;
var Oauth = /** @class */ (function () {
    function Oauth(id, medium, email, team_id, team_name, team_domain, external_avatar, created_at, updated_at) {
        this.id = id;
        this.medium = medium;
        this.email = email;
        this.team_id = team_id;
        this.team_name = team_name;
        this.team_domain = team_domain;
        this.external_avatar = external_avatar;
        this.created_at = created_at;
        this.updated_at = updated_at;
    }
    Oauth.fromJSON = function (json) {
        var oauth = new Oauth('', '', '', '', '', '', '', 0, 0);
        if (json && json.id) {
            oauth.id = json.id ? json.id : '';
            oauth.medium = json.medium ? json.medium : '';
            oauth.email = json.email ? json.email : '';
            oauth.team_id = json.team_id ? json.team_id : '';
            oauth.team_name = json.team_name ? json.team_name : '';
            oauth.team_domain = json.team_domain ? json.team_domain : '';
            oauth.external_avatar = json.external_avatar ? json.external_avatar : '';
            oauth.created_at = json.created_at ? json.created_at : 0;
            oauth.updated_at = json.updated_at ? json.updated_at : 0;
        }
        return oauth;
    };
    return Oauth;
}());
exports.Oauth = Oauth;
